import React from 'react';

import Button from 'common/components/Button';
import { useRewindContext } from 'common/components/RewindModal/RewindContext';
import { trackNextRewindModal } from 'common/tracking/rewindModal';

type NextButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  flashbackType?: number;
};

const NextButton = ({
  onClick,
  disabled = false,
  flashbackType: flashbackTypeProp
}: NextButtonProps) => {
  const {
    flashbackType: flashbackTypeContext,
    screenName,
    trackingScreenName
  } = useRewindContext();
  const flashbackType = flashbackTypeProp ?? flashbackTypeContext;

  const handleClick = () => {
    if (trackingScreenName === 'screen_intro_rewind') {
      trackNextRewindModal({
        flashbackType,
        screenName: (trackingScreenName || screenName || '') as ScreenNames
      });
    }
    onClick();
  };

  return (
    <Button
      theme="squared"
      className="next-button icon icon-arrow-forward"
      size="sm"
      onClick={handleClick}
      disabled={disabled}
    >
      {' '}
    </Button>
  );
};

export default NextButton;
